import { confirm, loading, throttle, validate } from '@/commons/decorators/decorator';
import { Hospital } from '@/entities/hospital';
import { PhysicalInfo, UserForm } from '@/entities/physical';
import { MARITAL_STATUS } from '@/metas/user';
import physicalService from '@/services/physical.services';
import { Field, Form } from 'vant';
import { Component, Vue } from 'vue-property-decorator';

/**
 * 申请表单
 */
@Component({ name: 'ApplicationForm' })
export default class extends Vue {
    public $refs!: { form: Form };

    // 体检信息
    public physicalInfo: PhysicalInfo | null = null;

    // 选择的医院id
    public selectHospital: Hospital | null = null;

    // 医院弹框可见
    public hospitalPopupVisible: boolean | null = false;

    public loading: boolean = false;

    public MARITAL_STATUS = MARITAL_STATUS;

    // @ts-ignore
    public formData = new UserForm();

    /**
     * 确认选择医院
     */
    public handleSelectHospital(hospital: Hospital) {
        this.selectHospital = hospital;
        this.hospitalPopupVisible = false;
    }

    @loading()
    public created() {
        this.getUserInfo();
    }

    /**
     * 获取用户信息 医院信息
     */
    public async getUserInfo() {
        this.physicalInfo = await physicalService.getInfo();
        if (this.physicalInfo) {
            this.formData.sex = this.physicalInfo.userInfo.sex;
            this.formData.id_card = this.physicalInfo.userInfo.idCard;
            this.formData.mobile = this.physicalInfo.userInfo.mobile;
            this.formData.marital_status = Number(this.physicalInfo.userInfo.maritalStatus);
        }
    }

    /**
     * 提交申请单表单
     */
    @throttle(2000)
    @loading()
    @confirm('确认后无法再次修改')
    public async formSubmit() {
        this.loading = true;
        this.$notify.clear();
        setTimeout(async () => {
            try {
                const res = await physicalService.modifyUserInfo(this.formData);
                this.$notify({ type: 'success', message: res.message, duration: 1000 });
                this.loading = false;
                window.setTimeout(() => {
                    this.$router.go(-1);
                }, 1000);
            } catch (e) {
                console.log(e);
            }
        }, 200);
    }

    public beforeDestroy() {
        this.$notify.clear();
    }
}
